module.exports = __webpack_public_path__ + "static/media/Final_screen.1a94c649.png";